import React, { useContext } from 'react';
import { renderValue } from '../../utilities/utils';
import { ChangelogContext } from '../ChangelogTable/ChangelogContext';
import { useTranslation } from '@michelin/central-provider';
var CustomCell = function (props) {
    var value = props.value, data = props.data, metadata = props.metadata, field = props.field;
    var t = useTranslation().t;
    var context = useContext(ChangelogContext);
    return (React.createElement("div", null, renderValue(t, value, metadata[data.entity] || metadata['*'], context, data, undefined, undefined, undefined, field)));
};
export default CustomCell;
//# sourceMappingURL=CustomCell.js.map